import {ArrowRightIcon, InfoIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'

import {LABELS} from '../constants/labels'
import styles from './converted-to-discussion-banner.module.css'
import convertedStyles from './ConvertedToDiscussionBanner.module.css'

type ConvertedToDiscussionBannerProps = {
  discussionUrl: string
}

export const ConvertedToDiscussionBanner = ({discussionUrl}: ConvertedToDiscussionBannerProps) => {
  return (
    <div className={styles.bannerContainer}>
      <div className={styles.bannerContent}>
        <Octicon icon={InfoIcon} size={16} className={convertedStyles.infoIcon} />
        <div className={styles.textContent}>
          <span className={convertedStyles.convertedText}>{LABELS.convertToDiscussion.converted}</span>
          <Link href={discussionUrl} className={convertedStyles.discussionLink}>
            {LABELS.convertToDiscussion.goToDiscussion}
            <Octicon icon={ArrowRightIcon} size={16} className={convertedStyles.arrowIcon} />
          </Link>
        </div>
      </div>
    </div>
  )
}
